import { render, staticRenderFns } from "./SchoolOverallPerformance.vue?vue&type=template&id=0d731cb6&scoped=true&"
import script from "./SchoolOverallPerformance.vue?vue&type=script&lang=ts&"
export * from "./SchoolOverallPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolOverallPerformance.vue?vue&type=style&index=0&id=0d731cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d731cb6",
  null
  
)

export default component.exports